module.exports = __webpack_public_path__ + "img/country-road-half-2.e2aaa613.png";